import * as React from 'react';

import { TabsProps } from '@mui/material';
import {
  ApiMetricsGrid,
  EmployeesGrid,
  EmployeesStatsHeader,
  TabSelection,
  useAdminApiMetricGet,
} from 'shared-feature-stats';

import { usePersistedParam } from '@sbv-clients/domain-ui-shared';
import { Box, Tab, Tabs, Typography } from '@sbv-clients/ui-shared';

import { useAdminFacilityEmployeesGet } from '../../services/admin';
import { FacilitiesEmployeesGrid } from './facilities-employees-grid';
import { FilterHeader } from './filter-header';

function NewOldTabs({
  onlyNew,
  setOnlyNew,
}: {
  onlyNew: boolean;
  setOnlyNew: (value: boolean) => void;
}) {
  const handleChange: TabsProps['onChange'] = (event, value) =>
    setOnlyNew(value !== 0);

  return (
    <Box pl={1} mt={4}>
      <Tabs value={onlyNew ? 1 : 0} onChange={handleChange}>
        <Tab label={'Legacy'} />
        <Tab label={'New'} />
      </Tabs>
    </Box>
  );
}

const pageKey = 'FacilityStatsPage';
export const FacilitiesStatsPage = () => {
  const [facilityId, setFacilityId] = usePersistedParam({
    pageKey,
    paramKey: 'facilityId',
    type: 'string',
    defaultValue: 'All',
  });
  const [onlyNew, setOnlyNew] = usePersistedParam({
    pageKey,
    paramKey: 'onlyNew',
    type: 'boolean',
    defaultValue: false,
  });
  const [tab, setTab] = usePersistedParam({
    pageKey,
    paramKey: 'tab',
    type: 'number',
    defaultValue: TabSelection.all,
  });
  const [groupByShift, setGroupByShift] = usePersistedParam({
    pageKey,
    paramKey: 'groupByShift',
    type: 'boolean',
    defaultValue: false,
  });
  const [filterByWeekend, setFilterByWeekend] = usePersistedParam({
    pageKey,
    paramKey: 'filterByWeekend',
    type: 'boolean',
    defaultValue: false,
  });

  const { data, isLoading, isError, error } = useAdminFacilityEmployeesGet(
    facilityId,
    onlyNew
  );

  const {
    data: aData,
    isError: aIsError,
    isLoading: aIsLoading,
    error: aError,
  } = useAdminApiMetricGet(facilityId === 'All' ? null : facilityId);

  return (
    <Box sx={{ p: 6, height: '100%', overflowY: 'auto', overflowX: 'hidden' }}>
      <FilterHeader
        isNew={data?.useSchedulerWebsite}
        facilityId={facilityId}
        setFacilityId={setFacilityId}
      />
      {facilityId === 'All' && (
        <NewOldTabs onlyNew={onlyNew} setOnlyNew={setOnlyNew} />
      )}
      <EmployeesStatsHeader
        groupByShift={groupByShift}
        setGroupByShift={setGroupByShift}
        filterByWeekend={filterByWeekend}
        setFilterByWeekend={setFilterByWeekend}
        tab={tab}
        setTab={setTab}
        isLoading={isLoading}
        isError={isError}
        error={error}
        data={data?.employeeMetrics}
        totalEmployees={data?.employeeMetrics?.totalFacilityEmployeeCount}
      />
      <Box height={700}>
        {facilityId === 'All' ? (
          <FacilitiesEmployeesGrid
            groupByShift={groupByShift}
            filterByWeekend={filterByWeekend}
            tab={tab}
            data={data?.employeeAggregates || []}
            isLoading={isLoading}
            isError={isError}
            error={error}
          />
        ) : (
          <EmployeesGrid
            groupByShift={groupByShift}
            filterByWeekend={filterByWeekend}
            tab={tab}
            data={data?.employeeAggregates || []}
            isLoading={isLoading}
            isError={isError}
            error={error}
          />
        )}
      </Box>
      <Typography my={4} variant={'h4'}>
        Api Metrics
      </Typography>
      <Box height={700}>
        <ApiMetricsGrid
          data={aData || []}
          isLoading={aIsLoading}
          isError={aIsError}
          error={aError}
        />
      </Box>
    </Box>
  );
};
